import { useModal } from '@ebay/nice-modal-react'

import loginBonusIcon from '../../assets/login-bonus/login-bonus-icon.gif'
import shadow from '../../assets/profile/freespin_shadow.webp'
import { useBoundStore } from '../../store/store'
import LoginBonus from './login-bonus'

type LoginBonusBtn = {
  closeProfileDrawer?: () => void
}

const LoginBonusBtn = ({ closeProfileDrawer }: LoginBonusBtn) => {
  const loginBonus = useModal(LoginBonus)
  const username = useBoundStore(state => state.user.username)
  const isEnabled = useBoundStore(state => state.settings.bonus_daily.value)

  if (!username || !isEnabled) return null

  return (
    <span
      className="absolute z-[5] w-[70px] h-[70px] cursor-pointer left-[15px] top-2 xl:left-[unset] xl:right-[122px] xl:top-5"
      onClick={() => {
        closeProfileDrawer?.()
        loginBonus.show()
      }}>
      <img
        className="w-[70px] absolute z-[1] left-0 top-0"
        src={loginBonusIcon}
        alt="Bonus"
      />
      <img
        className="absolute left-[-18px] w-[110px] -top-1"
        src={shadow}
        alt="Shadow"
      />
    </span>
  )
}

export default LoginBonusBtn
